import React, { useEffect, useState } from 'react';
import '../styles/Form.module.scss';
export default function Formm(_a) {
    var children = _a.children, errorModel = _a.errorModel, onSubmit = _a.onSubmit;
    var _b = useState([]), fields = _b[0], setFields = _b[1];
    // go through each child and register it as a form field
    useEffect(function () {
        var newFields = React.Children.map(children, function (child) {
            var _a = child.props, name = _a.name, label = _a.label, type = _a.type, required = _a.required, options = _a.options;
            return { name: name, label: label, type: type, required: required, options: options };
        });
        setFields(newFields);
    }, [children]);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: onSubmit },
            fields.map(function (field) { return (React.createElement("div", { key: field.name },
                React.createElement("label", { htmlFor: field.name }, field.label),
                field.type === 'select' ? (React.createElement("select", { id: field.name, name: field.name, required: field.required }, field.options.map(function (option) { return (React.createElement("option", { key: option, value: option }, option)); }))) : (React.createElement("input", { type: field.type, id: field.name, name: field.name, required: field.required })),
                React.createElement("span", { className: "form_error" }, errorModel === null || errorModel === void 0 ? void 0 : errorModel[field.name]))); }),
            React.createElement("button", { type: "submit" }, "Submit"))));
}
